export default __webpack_public_path__ + "static/CVN Spanish-6c6bf8b00e4d8fdaec72dfc3302ae38c.pdf";